import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  standalone: true,
  selector: 'app-sem-acesso',
  templateUrl: './sem-acesso.component.html',
  styleUrls: ['./sem-acesso.component.scss'],
  imports: [CommonModule, ButtonModule]
})
export class SemAcessoComponent {
  private router = inject(Router);

  voltarAoLogin(): void {
    this.router.navigate(['/login']);
  }
}
